import { render, staticRenderFns } from "./NumberCircle.vue?vue&type=template&id=70c12232&scoped=true&lang=pug&"
import script from "./NumberCircle.vue?vue&type=script&lang=js&"
export * from "./NumberCircle.vue?vue&type=script&lang=js&"
import style0 from "./NumberCircle.vue?vue&type=style&index=0&id=70c12232&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c12232",
  null
  
)

export default component.exports